import api from '../../api';

const savedUser = {
  id: localStorage.getItem('userId') || null,
  token: localStorage.getItem('token') || null,
  role: localStorage.getItem('role') || null,
  username: localStorage.getItem('username') || null,
};

const state = {
  user: savedUser,
  onlineUsers: [],
  errorMessage: null,
  initialized: false,
};

const mutations = {
  setUser(state, payload) {
    const user = payload.user || payload;
    state.user = {
      id: user.id || payload.userId || localStorage.getItem('userId'),
      token: payload.token || user.token,
      role: user.role || payload.role,
      username: user.username || payload.username,
    };
    localStorage.setItem('token', state.user.token);
    localStorage.setItem('role', state.user.role);
    localStorage.setItem('username', state.user.username);
    if (state.user.id) localStorage.setItem('userId', state.user.id);
  },
  clearUser(state) {
    state.user = { id: null, token: null, role: null, username: null };
    state.onlineUsers = [];
    ['token', 'role', 'username', 'userId'].forEach((key) => localStorage.removeItem(key));
  },
  setOnlineUsers(state, users) {
    state.onlineUsers = users;
  },
  setErrorMessage(state, message) {
    state.errorMessage = message;
  },
  clearErrorMessage(state) {
    state.errorMessage = null;
  },
  setInitialized(state, value) {
    state.initialized = value;
  },
};

const actions = {
  async register({ commit }, user) {
    try {
      const { data } = await api.post('/api/auth/register', user);
      if (data.token) commit('setUser', data);
      commit('clearErrorMessage');
      return data;
    } catch (error) {
      commit('setErrorMessage', error.response?.data?.message || 'Registration failed');
      throw error;
    }
  },
  async login({ commit }, credentials) {
    try {
      const { data } = await api.post('/api/auth/login', credentials);
      commit('setUser', data);
      commit('clearErrorMessage');
      return data;
    } catch (error) {
      commit('setErrorMessage', error.response?.data?.message || 'Invalid username or password');
      throw error;
    }
  },
  async loadMe({ commit }) {
    try {
      const { data } = await api.get('/api/auth/me');
      commit('setUser', { user: data.user, token: localStorage.getItem('token') });
      commit('clearErrorMessage');
      return data.user;
    } catch (error) {
      commit('clearUser');
      return null;
    } finally {
      commit('setInitialized', true);
    }
  },
  async changePassword({ commit }, passwords) {
    try {
      await api.patch('/api/auth/change-password', passwords);
      commit('clearErrorMessage');
    } catch (error) {
      commit('setErrorMessage', error.response?.data?.message || 'Password change failed');
      throw error;
    }
  },
  logout({ commit }) {
    commit('clearUser');
  },
};

const getters = {
  isAuthenticated: (state) => Boolean(state.user.token),
  isAdmin: (state) => state.user.role === 'admin',
  isUser: (state) => ['user', 'operator', 'admin'].includes(state.user.role),
  isGuest: (state) => state.user.role === 'guest',
  userRole: (state) => state.user.role,
  userId: (state) => state.user.id,
  username: (state) => state.user.username,
  errorMessage: (state) => state.errorMessage,
  onlineUsers: (state) => state.onlineUsers,
  isInitialized: (state) => state.initialized,
};

export default { namespaced: true, state, mutations, actions, getters };
